<template>
  <section class="become-client-section" id="process">
    <v-container class="become-container">
      <!-- Section Title -->
      <h2 class="section-title animate-block">{{ $t('process.sectionTitle') }}</h2>

      <!-- Steps Grid -->
      <div class="steps-grid">
        <!-- Step 1 -->
        <div class="animate-block step-card step-card-default">
          <div class="step-content">
            <div class="step-icon">
              <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2" d="M22 2V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H2C1.46957 26 0.960859 25.7893 0.585786 25.4142C0.210714 25.0391 0 24.5304 0 24V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H20C20.5304 0 21.0391 0.210714 21.4142 0.585786C21.7893 0.960859 22 1.46957 22 2Z" fill="#1FB1C1"/>
              </svg>
              <svg class="step-digit" width="7" height="22" viewBox="0 0 7 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.00027 1.00031V21.0003C7.00027 21.2655 6.89491 21.5199 6.70738 21.7074C6.51984 21.895 6.26548 22.0003 6.00027 22.0003C5.73505 22.0003 5.4807 21.895 5.29316 21.7074C5.10562 21.5199 5.00027 21.2655 5.00027 21.0003V2.76656L1.51527 4.85781C1.28785 4.9944 1.01548 5.03504 0.758085 4.97081C0.500691 4.90658 0.279355 4.74273 0.142768 4.51531C0.00618187 4.28789 -0.0344666 4.01552 0.0297646 3.75813C0.0939958 3.50073 0.257845 3.2794 0.485268 3.14281L5.48527 0.14281C5.63703 0.0516346 5.81026 0.00238202 5.98729 8.4251e-05C6.16431 -0.00221352 6.33878 0.042526 6.49285 0.129732C6.64692 0.216937 6.77508 0.343482 6.86423 0.496436C6.95338 0.649391 7.00032 0.823271 7.00027 1.00031Z" fill="#1FB1C1"/>
              </svg>
            </div>
            <div class="step-text-area">
              <h3 class="step-title">{{ $t('process.steps[0].title') }}</h3>
              <p class="step-description">{{ $t('process.steps[0].description') }}</p>
            </div>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="animate-block step-card step-card-default">
          <div class="step-content">
            <div class="step-icon">
              <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2" d="M22 2V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H2C1.46957 26 0.960859 25.7893 0.585786 25.4142C0.210714 25.0391 0 24.5304 0 24V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H20C20.5304 0 21.0391 0.210714 21.4142 0.585786C21.7893 0.960859 22 1.46957 22 2Z" fill="#1FB1C1"/>
              </svg>
              <svg class="step-digit" width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 20.9981C12 21.2633 11.8946 21.5176 11.7071 21.7052C11.5196 21.8927 11.2652 21.9981 11 21.9981H1C0.814289 21.9981 0.632245 21.9463 0.474269 21.8487C0.316293 21.7511 0.188626 21.6114 0.105573 21.4453C0.0225203 21.2792 -0.0126368 21.0932 0.00404117 20.9082C0.0207191 20.7233 0.0885731 20.5466 0.2 20.3981L9.1925 8.40805C9.51341 7.98901 9.74821 7.5106 9.88337 7.00039C10.0185 6.49019 10.0514 5.95828 9.98005 5.43532C9.9087 4.91236 9.73455 4.40869 9.46766 3.95334C9.20076 3.49799 8.84638 3.09997 8.42495 2.7822C8.00352 2.46444 7.52337 2.23322 7.01217 2.10187C6.50097 1.97053 5.96883 1.94165 5.44642 2.01691C4.924 2.09217 4.42165 2.27007 3.96831 2.54037C3.51497 2.81066 3.1196 3.16801 2.805 3.5918C2.61693 3.84187 2.45838 4.11284 2.3325 4.3993C2.22625 4.64231 2.02781 4.83315 1.78085 4.92985C1.53389 5.02655 1.25863 5.02118 1.01563 4.91493C0.772621 4.80867 0.581778 4.61024 0.485079 4.36328C0.388381 4.11632 0.393748 3.84106 0.5 3.59805C0.839049 2.82194 1.33856 2.12641 1.96569 1.55719C2.59282 0.987976 3.33335 0.557975 4.13857 0.295473C4.9438 0.0329703 5.79548 -0.0560859 6.63759 0.0341616C7.4797 0.124409 8.29316 0.391915 9.02448 0.819086C9.75579 1.24626 10.3884 1.82341 10.8807 2.51259C11.3729 3.20177 11.7137 3.98736 11.8806 4.81769C12.0475 5.64802 12.0367 6.50427 11.8489 7.33013C11.6612 8.15599 11.3007 8.93274 10.7913 9.6093L3 19.9981H11C11.2652 19.9981 11.5196 20.1034 11.7071 20.2909C11.8946 20.4785 12 20.7328 12 20.9981Z" fill="#1FB1C1"/>
              </svg>
            </div>
            <div class="step-text-area">
              <h3 class="step-title">{{ $t('process.steps[1].title') }}</h3>
              <p class="step-description">{{ $t('process.steps[1].description') }}</p>
            </div>
          </div>
        </div>

        <!-- Step 3 (Special - Teal) -->
        <div class="animate-block step-card step-card-special">
          <div class="step-content">
            <div class="step-icon">
              <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2" d="M22 2V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H2C1.46957 26 0.960859 25.7893 0.585786 25.4142C0.210714 25.0391 0 24.5304 0 24V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H20C20.5304 0 21.0391 0.210714 21.4142 0.585786C21.7893 0.960859 22 1.46957 22 2Z" fill="#F1F1F1"/>
              </svg>
              <svg class="step-digit" width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.0246 15C12.0245 16.3512 11.6333 17.6735 10.8983 18.8074C10.1633 19.9412 9.11587 20.838 7.88239 21.3897C6.64891 21.9413 5.28213 22.1242 3.94702 21.9162C2.6119 21.7082 1.36552 21.1182 0.358313 20.2175C0.255466 20.1315 0.170976 20.0256 0.109868 19.9062C0.0487599 19.7869 0.0122835 19.6564 0.00260709 19.5227C-0.00706936 19.3889 0.0102521 19.2546 0.0535419 19.1277C0.0968317 19.0008 0.165205 18.8839 0.254595 18.7839C0.343984 18.684 0.452565 18.603 0.573877 18.5459C0.695189 18.4887 0.826753 18.4566 0.960746 18.4513C1.09474 18.446 1.22842 18.4678 1.35384 18.5152C1.47926 18.5627 1.59386 18.6349 1.69081 18.7275C2.29496 19.2676 3.02133 19.6528 3.80739 19.8499C4.59344 20.047 5.41562 20.05 6.20313 19.8588C6.99063 19.6676 7.71986 19.2878 8.32801 18.7522C8.93616 18.2166 9.405 17.5412 9.69418 16.7842C9.98335 16.0271 10.0842 15.2112 9.98799 14.4065C9.8918 13.6018 9.60147 12.8326 9.14199 12.1651C8.68252 11.4976 8.06768 10.9517 7.35041 10.5745C6.63314 10.1974 5.83495 10.0002 5.02456 10C4.83885 10 4.65681 9.94829 4.49883 9.85065C4.34086 9.75302 4.21319 9.61332 4.13014 9.44721C4.04708 9.28111 4.01193 9.09516 4.0286 8.91019C4.04528 8.72523 4.11314 8.54857 4.22456 8.4L9.02456 2H1.02456C0.759347 2 0.504993 1.89464 0.317457 1.70711C0.129921 1.51957 0.0245635 1.26522 0.0245635 1C0.0245635 0.734784 0.129921 0.48043 0.317457 0.292893C0.504993 0.105357 0.759347 0 1.02456 0H11.0246C11.2103 0 11.3923 0.0517147 11.5503 0.149349C11.7083 0.246984 11.8359 0.386681 11.919 0.552786C12.002 0.718892 12.0372 0.904844 12.0205 1.08981C12.0038 1.27477 11.936 1.45143 11.8246 1.6L6.84456 8.24C8.33016 8.64219 9.64218 9.52194 10.5783 10.7436C11.5144 11.9652 12.0226 13.4609 12.0246 15Z" fill="#F1F1F1"/>
              </svg>
            </div>
            <div class="step-text-area">
              <h3 class="step-title step-title-light">{{ $t('process.steps[2].title') }}</h3>
              <p class="step-description step-description-light">{{ $t('process.steps[2].description') }}</p>
            </div>
            <button class="calculate-btn" @click="eventBus.showContactModal = true">
              <span>{{ $t('process.steps[2].btn') }}</span>
              <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.7196 8.87567L9.93836 13.6569C9.83868 13.7566 9.70347 13.8126 9.5625 13.8126C9.42153 13.8126 9.28632 13.7566 9.18664 13.6569C9.08696 13.5572 9.03095 13.422 9.03095 13.2811C9.03095 13.1401 9.08696 13.0049 9.18664 12.9052L13.0614 9.03106H2.65625C2.51535 9.03106 2.38023 8.97509 2.2806 8.87546C2.18097 8.77583 2.125 8.6407 2.125 8.49981C2.125 8.35891 2.18097 8.22379 2.2806 8.12416C2.38023 8.02453 2.51535 7.96856 2.65625 7.96856H13.0614L9.18664 4.09442C9.08696 3.99473 9.03095 3.85953 9.03095 3.71856C9.03095 3.57758 9.08696 3.44238 9.18664 3.3427C9.28632 3.24301 9.42153 3.18701 9.5625 3.18701C9.70347 3.18701 9.83868 3.24301 9.93836 3.3427L14.7196 8.12395C14.769 8.17329 14.8082 8.23188 14.8349 8.29637C14.8617 8.36086 14.8754 8.42999 14.8754 8.49981C14.8754 8.56962 14.8617 8.63875 14.8349 8.70324C14.8082 8.76774 14.769 8.82633 14.7196 8.87567Z" fill="#FBFBFB"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Step 4 -->
        <div class="animate-block step-card step-card-alt">
          <div class="step-content">
            <div class="step-icon">
              <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2" d="M22 2V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H2C1.46957 26 0.960859 25.7893 0.585786 25.4142C0.210714 25.0391 0 24.5304 0 24V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H20C20.5304 0 21.0391 0.210714 21.4142 0.585786C21.7893 0.960859 22 1.46957 22 2Z" fill="#1FB1C1"/>
              </svg>
              <svg class="step-digit" width="15" height="23" viewBox="0 0 15 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.9995 14.9705C14.9995 15.2357 14.8941 15.49 14.7066 15.6776C14.519 15.8651 14.2647 15.9705 13.9995 15.9705H11.9995V21.9705C11.9995 22.2357 11.8941 22.49 11.7066 22.6776C11.519 22.8651 11.2647 22.9705 10.9995 22.9705C10.7343 22.9705 10.4799 22.8651 10.2924 22.6776C10.1048 22.49 9.99948 22.2357 9.99948 21.9705V15.9705H0.999477C0.839279 15.9704 0.681445 15.9318 0.539264 15.858C0.397082 15.7842 0.274714 15.6773 0.182461 15.5463C0.0902071 15.4154 0.0307683 15.2641 0.00914859 15.1054C-0.0124711 14.9467 0.0043609 14.7851 0.0582275 14.6342L5.05823 0.634204C5.15326 0.392425 5.33864 0.197115 5.57514 0.0896225C5.81165 -0.0178703 6.0807 -0.0291086 6.32534 0.0582867C6.56998 0.145682 6.77101 0.324851 6.88587 0.557863C7.00073 0.790876 7.0204 1.05944 6.94073 1.3067L2.41823 13.9705H9.99948V7.97045C9.99948 7.70524 10.1048 7.45088 10.2924 7.26335C10.4799 7.07581 10.7343 6.97045 10.9995 6.97045C11.2647 6.97045 11.519 7.07581 11.7066 7.26335C11.8941 7.45088 11.9995 7.70524 11.9995 7.97045V13.9705H13.9995C14.2647 13.9705 14.519 14.0758 14.7066 14.2633C14.8941 14.4509 14.9995 14.7052 14.9995 14.9705Z" fill="#1FB1C1"/>
              </svg>
            </div>
            <div class="step-text-area">
              <h3 class="step-title">{{ $t('process.steps[3].title') }}</h3>
              <p class="step-description">{{ $t('process.steps[3].description') }}</p>
            </div>
          </div>
        </div>

        <!-- Empty card 1 (row 2, col 1) -->
        <div class="empty-card"></div>

        <!-- Empty card 2 (row 2, col 2) -->
        <div class="empty-card"></div>

        <!-- Step 5 (row 2, col 3 - under Step 3) -->
        <div class="animate-block step-card step-card-default">
          <div class="step-content">
            <div class="step-icon">
              <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.2" d="M22 2V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H2C1.46957 26 0.960859 25.7893 0.585786 25.4142C0.210714 25.0391 0 24.5304 0 24V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H20C20.5304 0 21.0391 0.210714 21.4142 0.585786C21.7893 0.960859 22 1.46957 22 2Z" fill="#1FB1C1"/>
              </svg>
              <span class="step-digit-text">5</span>
            </div>
            <div class="step-text-area">
              <h3 class="step-title">{{ $t('process.steps[4].title') }}</h3>
              <p class="step-description">{{ $t('process.steps[4].description') }}</p>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import { eventBus } from '@/eventBus'
import { animateOnScroll } from '@/mixins/animateOnScroll'

export default {
  name: 'BecomeClientSection',
  mixins: [animateOnScroll],
  setup() {
    return { eventBus }
  }
}
</script>

<style scoped>
.become-client-section {
  scroll-margin-top: 126px;
  background-color: #ededed;
  display: flex;
  justify-content: center;
  padding: 80px 0 40px;
}

.become-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
}

.section-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 41.6px;
  color: rgb(46, 46, 46);
  margin: 0;
}

/* Grid */
.steps-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  width: 100%;
}

/* Card */
.step-card {
  height: 350px;
  padding: 0 20px;
}

.step-card-default {
  background-color: #dedede;
}

.step-card-special {
  background-color: #1fb1c1;
}

.step-card-alt {
  background-color: #e4e4e4;
}

.empty-card {
  background-color: #ededed;
  height: 350px;
}

/* Content */
.step-content {
  display: flex;
  flex-direction: column;
  max-width: 245px;
  width: 100%;
  padding: 37px 0 0;
  height: 100%;
}

/* Icon */
.step-icon {
  width: 32px;
  height: 32px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.step-digit {
  position: absolute;
}

.step-digit-text {
  position: absolute;
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #1FB1C1;
  line-height: 1;
}

/* Text Area */
.step-text-area {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 20px;
}

/* Title */
.step-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 28.6px;
  color: rgb(46, 46, 46);
  margin: 0;
  min-height: 57.2px;
}

.step-title-light {
  color: rgb(241, 241, 241);
}

/* Description */
.step-description {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.01em;
  line-height: 18px;
  color: rgb(46, 46, 46);
  margin: 0;
}

.step-description-light {
  color: rgb(241, 241, 241);
}

/* Calculate Button */
.calculate-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  max-width: 245px;
  width: 100%;
  height: 38px;
  background-color: #2e2e2e;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-family: "SF Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 11px;
  letter-spacing: -0.03em;
  line-height: 16.8px;
  color: rgb(241, 241, 241);
  text-align: center;
  margin-top: auto;
  margin-bottom: 37px;
  transition: background-color 0.2s ease;
}

.calculate-btn:hover {
  background-color: #1a1a1a;
}

/* Responsive */
@media (max-width: 960px) {
  .become-client-section {
    padding: 60px 0;
  }

  .steps-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .empty-card {
    display: none;
  }

  .step-content {
    max-width: none;
  }

  .calculate-btn {
    max-width: none;
  }
}

@media (max-width: 600px) {
  .become-client-section {
    padding: 40px 0;
  }

  .steps-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .section-title {
    font-size: 24px;
    line-height: 32px;
  }

  .step-card {
    height: 280px;
    padding: 0 16px;
  }

  .step-text-area {
    gap: 8px;
  }

  .step-title {
    font-size: 12px;
    line-height: 18px;
    min-height: 36px;
  }

  .step-description {
    font-size: 10px;
    line-height: 15px;
  }
}
</style>
